export default {
  stepper: {
    description: 'Onboarding restauracji',
    steps: {
      confirm_email: 'Potwierdź adres e-mail',
      add_store_details: 'Dodaj dane swojego sklepu',
      add_personal_details: 'Dodaj swoje dane osobowe',
      add_bank_details: 'Dodaj dane bankowe do wypłat',
      add_tax_details: 'Czy Twoja firma jest płatnikiem VAT?',
      upload_business_doc: 'Dokument potwierdzający działalność',
      upload_personal_doc: 'Dokument potwierdzający tożsamość',
      confirm_details: 'Otrzymaj płatność',
    },
  },
  toasts: {
    failed_to_skip_verification_step: 'Nie udało się pominąć kroku weryfikacji. Spróbuj ponownie',
  },
};
